import { ISkills } from "../Interfaces/ISkills";
import { db } from "../db";
import { set , ref, remove } from "firebase/database"


export function NovaSkill({ID,skill,area}:ISkills) {
    set(ref(db,`skills/${ID}`),{
        skill:skill,
        area: area
    })
}

export function RemoverSkill(ID:string){
    remove(ref(db,`skills/${ID}`))
}

